import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  position: relative;
  padding-top: 50px;
`;

export default Container;
